const API = "https://feitevmd2k.execute-api.ap-south-1.amazonaws.com/prod";
const TOKEN_KEY = "ootygo_partner_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function req(path, { method = "GET", body, auth = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const t = getToken();
    if (t) headers.Authorization = `Bearer ${t}`;
  }
  const res = await fetch(API + path, { method, headers, body: body ? JSON.stringify(body) : undefined });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || "Request failed");
  return data;
}

export const partnerRegister = (b) => req("/partner/register", { method: "POST", body: b });
export const partnerLogin    = (b) => req("/partner/login", { method: "POST", body: b });
export const partnerForgot   = (email) => req("/partner/forgot-password", { method: "POST", body: { email } });
export const partnerReset    = (token, password) => req("/partner/reset-password", { method: "POST", body: { token, password } });
export const partnerMe       = () => req("/partner/me", { auth: true });
export const listMyAds       = () => req("/partner/ads", { auth: true });
export const createAd        = (b) => req("/partner/ads", { method: "POST", body: b, auth: true });
export const updateAd        = (id, b) => req(`/partner/ads/${id}`, { method: "PUT", body: b, auth: true });
export const deleteAd        = (id) => req(`/partner/ads/${id}`, { method: "DELETE", auth: true });
export const payAd           = (id) => req(`/partner/ads/${id}/pay`, { method: "POST", auth: true });
export const verifyPay       = (b) => req("/partner/ads/pay-verify", { method: "POST", body: b, auth: true });
export const publicAds       = (type) => req(`/public/ads${type ? `?type=${type}` : ""}`);
export const publicPlans     = () => req("/public/partner-plans");
export const updateProfile   = (b) => req("/partner/me", { method: "PUT", body: b, auth: true });
export const getPartnerProfile = (slug) => req(`/public/partner-profile/${encodeURIComponent(slug)}`);
export const subscribePlan   = (planId) => req("/partner/subscribe", { method: "POST", body: { planId }, auth: true });
export const subscribeVerify = (b) => req("/partner/subscribe-verify", { method: "POST", body: b, auth: true });

const getUploadUrl = (id, b) => req(`/partner/ads/${id}/upload-url`, { method: "POST", body: b, auth: true });

/** Upload a file to S3 via presigned PUT, returns the public file URL. */
export async function uploadFile(adId, file) {
  const { uploadUrl, fileUrl } = await getUploadUrl(adId, { fileName: file.name, contentType: file.type });
  const put = await fetch(uploadUrl, { method: "PUT", headers: { "Content-Type": file.type }, body: file });
  if (!put.ok) throw new Error("Upload failed");
  return fileUrl;
}

/** Load the Razorpay checkout script once. */
export function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}
